export const getWebmasterPermissionDeniedGuard = (ownerEmail?: string | null): string =>
    `У вас недостаточно прав для просмотра статуса, обратитесь к ${
        ownerEmail || 'владельцу аккаунта в Вебмастере'
    } для получения прав`;
